import React, { useEffect, useState } from "react";
import styled from "styled-components";
import useSound from "use-sound";
import playSound from "../assets/play.mp3";
import correctSound from "../assets/correct.mp3";
import wrongSound from "../assets/wrong.mp3";

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const Question = styled.div`
  background: linear-gradient(#100241, black);
  color: white;
  padding: 20px;
  border: 2px solid white;
  border-radius: 15px;
  text-align: center;
  font-size: 20px;
  width: 80%;
  font-weight: 400;
  @media only screen and (max-width: 767px) {
    font-size: 14px;
    font-weight: 200;
  }
`;

const Answers = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  font-size: 20px;
  font-weight: 400;
`;

const Quiz = ({
  data,
  questionNumber,
  setQuestionNumber,
  setStop,
  selectedAnswer,
  setSelectedAnswer,
  setCongrat,
}) => {
  const [question, setQuestion] = useState(null);
  const [className, setClassName] = useState("answer");
  const [letsPlay] = useSound(playSound);
  const [correctAnswer] = useSound(correctSound);
  const [wrongAnswer] = useSound(wrongSound);
  useEffect(() => {
    letsPlay();
  }, [letsPlay]);

  const delay = (duration, callback) => {
    setTimeout(() => {
      callback();
    }, duration);
  };

  const handleClick = (a) => {
    setSelectedAnswer(a);
    setClassName("answer active");
    delay(3000, () =>
      setClassName(a.correct ? "answer correct" : "answer wrong")
    );
    delay(5000, () => {
      questionNumber < 15 ? console.log("congrat") : setCongrat(true);

      if (a.correct) {
        correctAnswer();
        delay(1000, () => {
          setQuestionNumber((prev) => prev + 1);
          setSelectedAnswer(null);
        });
      } else {
        wrongAnswer();
        delay(1000, () => {
          setStop(true);
        });
      }
    });
  };

  useEffect(() => {
    setQuestion(data[questionNumber - 1]);
  }, [data, questionNumber]);

  return (
    <Container>
      <Question>{question?.question}</Question>

      <Answers>
        {question?.answers.map((a) => (
          <div
            key={a.text}
            className={selectedAnswer === a ? className : "answer"}
            onClick={() => !selectedAnswer && handleClick(a)}
          >
            {a.text}
          </div>
        ))}
      </Answers>
    </Container>
  );
};

export default Quiz;
